export const GLOBAL_SEARCH_SELECTOR_WIDTH = 110;
